module.exports = __webpack_public_path__ + "img/Peru1.32f69bcc.png";